import { useState, useEffect } from 'react'

// Window Size
// Get current window size to allow changes depending on resolutions
const useWindowSize = () => {
  const isBrowser = typeof window !== 'undefined'
  const getSize = () => {
    if (isBrowser) {
      return {
        width: window.innerWidth,
        height: window.innerHeight,
      }
    }
    return {
      width: 'auto',
      height: 'auto',
    }
  }
  const [windowSize, setWindowSize] = useState(getSize)

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getSize())
    }
    if (isBrowser) {
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }
  }, [])

  return windowSize
}
export default useWindowSize